import Image from "next/image";
import React, { FC, Fragment } from "react";
import Link from "next/link";

interface Props {
  routes: { name: string; href: string }[];
}

const BreadCrumb: FC<Props> = ({ routes }) => (
  <div className="bg-breadcrumb container w-full">
    <div className="flex justify-start items-center py-3 md:px-4">
      <Link href="/">
        <div className="w-6 h-6 flex-shrink-0 mx-1">
          <Image src="/img/home.svg" alt="home" height={22} width={22} />
        </div>
      </Link>
      {routes.map(({ name, href }, index) => (
        <Fragment key={name}>
          {index ? (
            <Image
              src="/img/right-arrow-breadcrumb.svg"
              alt="arrow right"
              height={22}
              width={22}
              className="mx-1"
            />
          ) : null}
          <Link
            href={href}
            className={`cursor-pointer ${index === routes.length - 1 ? "text-primary truncate" : "text-gray-500"} font-medium`}
          >
            {name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()}
          </Link>
        </Fragment>
      ))}
    </div>
  </div>
);

export default BreadCrumb;
